import React from 'react';
import { DisplayContainer, Section } from '../../components';
import { images } from './config';
import '../index.scss';

const Design = () => {
    return (
        <Section
            title='design'
        >
            <DisplayContainer
                images={images}
            />
        </Section>
    )
}

export default Design;